// extracted by mini-css-extract-plugin
export default {"container":"our_services_container__NaCTr","item":"our_services_item__VTPH5","overlink":"our_services_overlink__BfTp+","title":"our_services_title__zKgy7"};